export const RESET_STORE = 'reset-store'
export const META_DETAILS = 'meta-details';
export const CATEGORY_LIST = 'category-list';
export const SERVICES_LIST = 'services-list';
export const GO_TO_CATEGORY_SELECTION = 'goto-category-selection';
export const GO_TO_SERVICES_SELECTION = 'GO_TO_SERVICES_SELECTION';
export const GO_TO_PHOTOS_SELECTION = 'GO_TO_PHOTOS_SELECTION';
export const SELECT_ALL_SERVICES_HANDLER = 'SELECT_ALL_SERVICES_HANDLER';
export const SELECT_INDIVIDUAL_SERVICES_HANDLER = 'SELECT_INDIVIDUAL_SERVICES_HANDLER';
export const SET_PHOTOS_TO_UPLOAD = 'SET_PHOTOS_TO_UPLOAD';
export const UPLOAD_SELECTED_PHOTOS_HANDLER = 'UPLOAD_SELECTED_PHOTOS_HANDLER';
